module.exports = __webpack_public_path__ + "img/HONEY.a3c01136.png";